import FlightIcon from '@hashicorp/react-hds/src/components/flight-icon'
import classNames from 'classnames'
import s from './style.module.css'

interface Benefit {
	iconName: string
	heading: string
	description: string
}

export interface BenefitSectionProps {
	theme: 'white' | 'blue'
	layout: 'vertical' | 'horizontal'
	heading: string
	description?: string
	benefits: Array<Benefit>
}

export default function BenefitSection({
	theme,
	layout,
	heading,
	description,
	benefits,
}: BenefitSectionProps) {
	return (
		<div className={classNames(s.benefitSection, s[theme])}>
			<div className={classNames(s.inner, s[layout])}>
				<header
					className={classNames(s.header, {
						[s.solo]: !description,
						[s.headerGrid]: layout === 'vertical',
					})}
				>
					<h2 className={s.heading}>{heading}</h2>
					{description ? <p className={s.description}>{description}</p> : null}
				</header>
				<ul className={s.benefits}>
					{benefits.map((benefit) => {
						return (
							<li key={benefit.heading} className={s.benefit}>
								<div className={classNames(s.icon, s[theme])}>
									<FlightIcon name={benefit.iconName} size={24} />
								</div>
								<h3 className={s.benefitHeading}>{benefit.heading}</h3>
								<p className={s.benefitDescription}>{benefit.description}</p>
							</li>
						)
					})}
				</ul>
			</div>
		</div>
	)
}
